/**
 * 응답페이지 검색어
 */
export const CHANGE = 'analysis/rows/search/CHANGE' // 값 변경시
export const INIT = 'analysis/rows/search/INIT'     // 초기 쿠키에서 값 가져올때

type Type = {
    search: string | number
}

// order: answer => 보기순, count => 응답순
// pointType: point => 가중치로 계산, count => 응답수로 계산 
const initState: Type = {
    search: ''
}
 
interface ActionProps {
    type: string;
    search: Type['search'];
}
 
export default (state = initState, action: ActionProps) => {
    switch(action.type) {
        case CHANGE:
            return {
                search: action.search
            }
        case INIT:
            return initState
        default:
            return state
    }
}